import { browser } from '$app/environment';
import { operations, transactions } from '$lib/constants/indexedDB-operations';
import type { BookmarkType } from '$lib/store/bookmarksStore';
import Logger from './logger';

// Export functions that interact with IndexedDB
export const getDB = async (dbName: string, storeName?: string) => {
  if (typeof window === 'undefined') {
    Logger.log('getDB can only be used on the client side');
  }
  // Dynamically import 'idb' here to avoid SSR issues
  const { openDB } = await import('idb');
  const db = openDB(dbName, undefined, {
    upgrade(db) {
      if (storeName && !db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: 'id' });
      }
    }
  });
  return db;
};

export const performDBOperation = async (
  action: operations,
  data: BookmarkType | string,
  dbName: string,
  storeName: string
): Promise<void> => {
  if (!browser) return;
  const db = await getDB(dbName, storeName);
  const tx = db.transaction(storeName, transactions.READ_WRITE);
  const store = tx.objectStore(storeName);

  try {
    if (action === operations.ADD) {
      await store.put(data as BookmarkType);
    } else {
      await store.delete(data as string);
    }
  } catch (error) {
    Logger.error('Error performing DB operation:', error);
    throw error; // Re-throw the error for proper error handling at a higher level
  }
};
